import { useState } from 'react';
import { DiffRange } from '../../../db/indexedDb';
import { SentenceScore } from '../types';

interface Props {
  score: SentenceScore;
}

const renderDiff = (ranges: DiffRange[]) =>
  ranges.map((range, index) => {
    const key = `diff-${index}`;
    switch (range.kind) {
      case 'hit':
        return (
          <span className="diff-chip hit" key={key}>
            {range.text}{' '}
          </span>
        );
      case 'typo':
        return (
          <span className="diff-chip typo" key={key} title={`拼写: ${range.actual}`}>
            {range.text}{' '}
          </span>
        );
      case 'missing':
        return (
          <span className="diff-chip missing" key={key}>
            {range.text}{' '}
          </span>
        );
      case 'extra':
        return (
          <span className="diff-chip extra" key={key}>
            {range.text}{' '}
          </span>
        );
      default:
        return (
          <span className="diff-chip" key={key}>
            {range.text}{' '}
          </span>
        );
    }
  });

export default function SentenceDiffResult({ score }: Props) {
  const [expanded, setExpanded] = useState(false);
  const status = score.coverage >= 80 ? 'good' : score.coverage >= 50 ? 'partial' : 'weak';

  return (
    <div className={`sentence-result ${status}`}>
      <button type="button" className="sentence-result-header" onClick={() => setExpanded(!expanded)}>
        <span className="sentence-index">#{score.index}</span>
        <span className="sentence-chinese">{score.chinese}</span>
        <span className={`coverage-badge ${status}`}>{score.coverage}%</span>
        <span className="expand-icon">{expanded ? '▼' : '▶'}</span>
      </button>

      {expanded && (
        <div className="sentence-result-body">
          <div className="diff-section">
            <p className="section-label">Diff 对比</p>
            <div className="diff-panel">{renderDiff(score.diffRanges)}</div>
          </div>
          <div className="answer-section">
            <p className="section-label">标准答案</p>
            <p className="standard-answer">{score.english}</p>
          </div>
          {score.answer && (
            <div className="answer-section">
              <p className="section-label">你的答案</p>
              <p className="user-answer">{score.answer}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
